import { IAccount } from '../types/types'
import { selectorFamily, useSetRecoilState } from 'recoil'
import { accountsState } from './accounts-state'
import { api } from '../utils/api'
import { usersState } from './users-state'

export const accountState = selectorFamily<IAccount | null, string>({
  key: 'accountState',
  get:
    (accountId: string) =>
    ({ get }) => {
      const account = get(accountsState).find((account) => account.id === accountId)

      return account || null
    },
})

export const useUpdateAccountState = () => {
  const setAccounts = useSetRecoilState(accountsState)

  return (account: IAccount) => {
    setAccounts((accounts) => {
      const newArray = Array.from(accounts)
      const index = Array.from(accounts).findIndex((a) => a.id === account.id)

      console.log(accounts, account, index)
      console.log(typeof accounts)
      if (index > -1) {
        newArray[index] = account
      }

      return [...newArray]
    })
  }
}

export const useRefreshAccountData = (accountId) => {
  const updateAccount = useUpdateAccountState()

  return async () => {
    try {
      const { data } = await api.post(`/account/${accountId}/refresh`)
      updateAccount(data.account)
    } catch (error) {
      console.log(error)
    }
  }
}

export const accountUsersState = selectorFamily<IAccount['users'], string>({
  key: 'accountUsersState',
  get: (accountId) => {
    return ({ get }) => {
      const users = get(usersState)
      // todo: filter many to many relationship
      return users
    }
  },
})